import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import { Button } from "semantic-ui-react";

import Modal from "components/Modal";
import MultipleStepsWrapper from "components/MultipleStepsWrapper";

import { useAddUser } from "./hooks";
import { NewUserInfoPage, SubscriptionInformationPage } from "./components";

export const useUserManagementModalStyles = makeStyles({
  modal: {
    "&": {
      minHeight: "500px",
      height: "80%",
    },
    "&.modal .content": {
      display: "flex",
      flexDirection: "column",
      height: "80%",
    },
    "&.modal form": {
      flex: "1",
      height: "80%",
    },
    "&.modal .actions": {
      position: "absolute",
      bottom: "0px",
      width: "100%",
    },
  },
});
function AddUserModal({ initialUsers, onSubmitCb, onClose }) {
  const classes = useUserManagementModalStyles();
  const {
    onSubmit,
    loading: submitting,
    loadingNotInvitedUser,
    userInfos,
    onCloseWithNotify,
    setUserInfos,
  } = useAddUser(initialUsers, onSubmitCb, onClose);

  return (
    <Modal
      data-test="add-users-modal"
      className={classes.modal}
      size="large"
      isModalOpen
      onClose={() => {
        setUserInfos([]);
        onCloseWithNotify();
      }}
    >
      <MultipleStepsWrapper>
        <NewUserInfoPage
          defaultNewUserInfo={userInfos}
          loadingNotInvitedUser={loadingNotInvitedUser}
          onChange={setUserInfos}
          onClose={onCloseWithNotify}
          cancelButton={
            <Button
              content="Discard Changes"
              basic
              type="button"
              onClick={onCloseWithNotify}
            />
          }
        />
        <SubscriptionInformationPage
          inviteCount={
            userInfos.filter((userInfo) => {
              return userInfo.inviteNow;
            }).length
          }
          loading={submitting}
          cancelButton={
            <Button
              content="Discard Changes"
              basic
              onClick={onCloseWithNotify}
              disabled={submitting}
            />
          }
          onSubmit={onSubmit}
          onClose={onCloseWithNotify}
        />
      </MultipleStepsWrapper>
    </Modal>
  );
}

AddUserModal.propTypes = {
  initialUsers: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      roleId: PropTypes.string,
      inviteNow: PropTypes.bool,
      crmListId: PropTypes.string,
    })
  ),
  onSubmitCb: PropTypes.func,
  onClose: PropTypes.func,
};

AddUserModal.defaultProps = {
  initialUsers: [],
  onSubmitCb: () => {},
  onClose: () => {},
};

export default AddUserModal;
